import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { CASE_STUDIES } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

export function CaseStudies() {
  return (
    <section id="work" className="relative py-24 lg:py-32" data-testid="case-studies">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-magenta">Case Studies</p>
          <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-none tracking-tight sm:text-5xl lg:text-6xl">
            Growth stories, in the open.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.id} delay={(i % 2) * 0.1}>
              <Link
                to={`/case-study/${c.id}`}
                data-testid={`case-card-${c.id}`}
                className="group relative block h-full w-full overflow-hidden rounded-2xl border border-white/8 bg-surface text-left"
              >
                <div className="relative h-56 overflow-hidden">
                  <img src={c.image} alt={c.client} className="h-full w-full object-cover opacity-70 transition-all duration-700 group-hover:scale-110 group-hover:opacity-100" />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/40 to-transparent" />
                  <span className="absolute left-5 top-5 rounded-full border border-white/20 bg-black/30 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-white backdrop-blur">
                    {c.tag}
                  </span>
                </div>
                <div className="p-7">
                  <div className="flex items-start justify-between">
                    <h3 className="font-display text-2xl font-bold">{c.client}</h3>
                    <ArrowUpRight className="h-5 w-5 text-muted transition-all group-hover:text-orange group-hover:rotate-45" />
                  </div>
                  <p className="mt-3 text-sm font-light leading-relaxed text-muted">{c.summary}</p>
                  <div className="mt-6 grid grid-cols-2 gap-3">
                    {c.results.slice(0, 2).map((r) => (
                      <div key={r.k} className="rounded-xl border border-white/8 bg-white/[0.02] p-3">
                        <div className="font-display text-xl font-black text-orange">{r.v}</div>
                        <div className="text-[11px] uppercase tracking-wide text-muted">{r.k}</div>
                      </div>
                    ))}
                  </div>
                  <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-white">
                    Read full case study <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
